import type { PropsWithChildren, ReactElement } from 'react';
import * as Sentry from '@sentry/react';

import { ErrorFallback } from './components/error-fallback.component';

export function AppErrorBoundary({ children }: PropsWithChildren): ReactElement {
  return (
    <Sentry.ErrorBoundary
      fallback={({ error, resetError }) => (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 p-4">
          <ErrorFallback error={error} onReset={resetError} />
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
